

export const frontMatter = {
	description: 'API',
	title: 'Panel API',
	sidebar_position: 2
};
export const contentTitle = undefined;
export const metadata = {
  "id": "api/paneview/panelApi",
  "title": "Panel API",
  "description": "API",
  "source": "@site/docs/api/paneview/panelApi.mdx",
  "sourceDirName": "api/paneview",
  "slug": "/api/paneview/panelApi",
  "permalink": "/docs/api/paneview/panelApi",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "sidebarPosition": 2,
  "frontMatter": {
    "description": "API",
    "title": "Panel API",
    "sidebar_position": 2
  },
  "sidebar": "api",
  "previous": {
    "title": "API",
    "permalink": "/docs/api/paneview/api"
  }
};
export const assets = {

};

import {jsx as _jsx} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [];
function _createMdxContent(props) {
  return _jsx(DocRef, {
    declaration: "PaneviewPanelApi"
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

